import {FieldsConfiguration, FieldsForm} from '../../fields/types'
import {Contact} from '../../types'

import {buildConfirmationPinForm} from './confirmationPin/buildConfirmationPinForm'
import {buildDateTimeForm} from './dateTime/buildDateTimeForm'
import {buildIsConfirmedForm} from './isConfirmed/buildIsConfirmedForm'
import {buildLoadBalanceForm} from './loadBalance/buildLoadBalanceForm'
import {buildLoadSpacingForm} from './loadSpacing/buildLoadSpacingForm'
import {buildMixForm} from './mix/buildMixForm'
import {buildOrderPlacerForm} from './orderPlacer/buildOrderPlacerForm'
import {buildPlusLoadForm} from './plusLoad/buildPlusLoadForm'
import {buildQuantityForm} from './quantity/buildQuantityForm'
import {buildRetarderForm} from './retarder/buildRetarderForm'
import {buildSiteContactForm} from './siteContact/buildSiteContactForm'
import {buildIsTestBookedForm} from './testing/buildIsTestBookedForm'
import {
  buildAdditionalNotesForm,
  buildDriverInstructionsForm,
  buildPoNumberForm
} from './textField/buildTextFieldForm'
import {buildTruckForm} from './trucks/buildTruckForm'
import {CreateFormInput} from './types'
import {buildUnloadingMethodForm} from './unloadingMethod/buildUnloadingMethodForm'
import {buildUsageForm} from './usage/buildUsageForm'

export const buildForm = (
  input: CreateFormInput<FieldsConfiguration>,
  contacts?: {
    orderPlacer?: Contact
    siteContact?: Contact
  }
): FieldsForm => {
  return {
    ...buildTruckForm(input),
    ...buildLoadSpacingForm(input),
    ...buildQuantityForm(input),
    ...buildPlusLoadForm(),
    ...buildLoadBalanceForm(),
    ...buildIsConfirmedForm(input),
    ...buildConfirmationPinForm(),
    ...buildRetarderForm(input),
    ...buildMixForm(input),
    ...buildDateTimeForm(input),
    ...buildSiteContactForm(contacts),
    ...buildOrderPlacerForm(contacts),
    ...buildAdditionalNotesForm(),
    ...buildDriverInstructionsForm(),
    ...buildPoNumberForm(),
    ...buildUnloadingMethodForm(),
    ...buildUsageForm(),
    ...buildIsTestBookedForm()
  }
}
